import styled from 'styled-components';

/* ------------------------------------------------------------------------ */
/* ----------------------------- Helper styles ---------------------------- */
/* ------------------------------------------------------------------------ */

const ScreenReaderText = styled.span`
  border: 0;
  clip: rect(0, 0, 0, 0);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  width: 1px;
`;

const ButtonReset = styled.button`
  appearance: none;
  background-color: transparent;
  border: none;
  border-radius: 0;
  cursor: pointer;
  overflow: visible;
  text-decoration: none;
`;

export default {
  ScreenReaderText,
  ButtonReset,
};
